<template>
	<v-hover v-slot="{ hover }">
		<v-card
			:class="['category-card', 'mx-auto', { 'on-hover scale': hover }]"
			:elevation="hover ? 10 : 2"
		>
			<v-img class="white--text align-end" height="175px" :src="img">
			</v-img>
		</v-card>
	</v-hover>
</template>

<script>
export default {
	name: "CardImage",

	props: ["img"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.category-card {
	cursor: pointer;
	transition: all 0.2s;
}
</style>
